import { ProviderCard } from "~/screens/Scheduling/ConfirmedVisit/components/provider-card";
import { VisitFooter } from "~/screens/Scheduling/ConfirmedVisit/components/visit-footer";
import { VisitSubtitle } from "~/screens/Scheduling/ConfirmedVisit/components/visit-subtitle";
import { VisitTitle } from "~/screens/Scheduling/ConfirmedVisit/components/visit-title";
import { ScheduleVisitResponse } from "~/services";
import { Button, Logo } from "~/shared";

type ConfirmedVisitProps = {
  appointment: ScheduleVisitResponse;
  handleContinue: () => void;
  buttonText: string;
  showAddToCalendar?: boolean;
};

export const ConfirmedVisit = ({
  appointment,
  handleContinue,
  buttonText,
  showAddToCalendar,
}: ConfirmedVisitProps) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="flex w-3/4 p-4 md:self-center">
        <Logo className="block h-8 md:h-10" />
      </div>

      <main className="mx-auto max-w-6xl gap-14 p-4 px-6 md:grid md:grid-cols-2">
        <aside className="hidden md:block">
          <VisitTitle />
          <VisitSubtitle />
        </aside>

        <div className="mb-8 md:hidden">
          <VisitTitle />

          <ProviderCard
            appointment={appointment}
            showAddToCalendar={showAddToCalendar}
          />
          <section className="my-6 space-y-4 leading-[21px]">
            <VisitSubtitle />
          </section>

          <Button className="w-full" onClick={handleContinue}>
            {buttonText}
          </Button>
          <VisitFooter />
        </div>

        <section className="mb-8 hidden md:block">
          <ProviderCard
            appointment={appointment}
            className="p-6"
            showAddToCalendar={showAddToCalendar}
          />

          <Button className="mt-6 w-full" onClick={handleContinue}>
            {buttonText}
          </Button>
          <VisitFooter />
        </section>
      </main>
    </div>
  );
};
